<div class="msin-background"></div>

<mat-card appearance="outlined" class="login-page">
	<mat-card-header>
		<mat-card-title>
			<a href="/login">
				<img class="login-logo" alt="MSIN Logo"
					src="../../../../assets/images/MSIN-Logo_Color-White-Text.png" />
			</a>
		</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>Resend Email Confirmation</mat-card-title>
				<mat-card-subtitle>
					Please enter the email address you included with your account request. You will receive an email
					shortly
					asking you to confirm your email address to begin the approval process.
				</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>
				<form [formGroup]="form" class="d-flex flex-column column">
					<mat-form-field style="width:100%;">
						<mat-label>Email</mat-label>
						<input matInput type="email" placeholder="Email" formControlName="email" />
					</mat-form-field>

					<!-- <app-recaptcha [form]="form"></app-recaptcha> -->

					<button class="w-100" mat-raised-button color="primary" (click)="submit()"
						[disabled]="!form.valid || isLoading">
						<mat-icon *ngIf="isLoading">
							<mat-spinner diameter="20"> </mat-spinner>
						</mat-icon>
						Submit
					</button>

					<app-msg [msg]="msg"></app-msg>
				</form>
			</mat-card-content>
		</mat-card>
		<mat-card appearance="outlined" class="margin-top-sm">
			<a mat-button href="/login">Back to Login</a>
		</mat-card>
	</mat-card-content>
</mat-card>